'use client'

import React from 'react'
import Swiper from '@/components/swiper'
import { SwiperSlide } from 'swiper/react'
import CampaignCard from '@/components/featured/common/cards/CampaignCard'
import { getLocalizedPath } from '@/utils/pathUtils'
import { PATHS } from '@/constants/pathnames'

function CampaignSwiper({ campaignsList }) {
  return (
    <Swiper
      customClass="relative z-0"
      swiperOptions={{
        slidesPerView: "auto",
        pagination: true,
        navigation: true,
      }}
    >
      {campaignsList.map((item, index) => (
        <SwiperSlide key={item.id || index} className="swiper-aspect-1-5 md:swiper-aspect-2-5 lg:swiper-aspect-4">
          <CampaignCard item={item} />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default CampaignSwiper